/**
 * @file: onErrorReturn.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export function onErrorReturn<T>(value: T | (() => T)): (error: any) => T {
  return (error: any) => {
    console.error(error);
    return typeof value === 'function' ? (value as any)() : value;
  };
}
